<template>
    <div style="padding: 20px;height: 100%;width: 100%">
        <div class="title">
            <div style="display: flex;align-items: center">
                <img src="../../../assets/img/icon.png" alt="" style="width: 24px;margin:0px 5px">
                <h3>调解确认案件趋势</h3>
            </div>
            <div style="font-size: 14px">环比
                <img src="../../../assets/img/up.png" alt="" v-if="echartsData.tiaojie_huanbi_jiajian==1">
                <img src="../../../assets/img/down.png" alt="" v-else>
                {{echartsData.tiaojie_huanbi}}%</div>
            <div style="font-size: 14px">同比
                <img src="../../../assets/img/up.png" alt="" v-if="echartsData.tiaojie_tongbi_jiajian==1">
                <img src="../../../assets/img/down.png" alt="" v-else>
                {{echartsData.tiaojie_tongbi}}%</div>
        </div>
        <div class="echartsBox">
            <div class="echarts" id="echarts" style="width: 100%;height: 100%"></div>
        </div>
    </div>
</template>

<script>
import * as echarts from "echarts";
export default {
    name:'tj_caseTrend',
    props:['echartsData'],
    data() {
        return {
            month:'',
            listData:'',
        };
    },
    mounted() {
        // this.setChart();
    },
    methods: {
        setChart() {
            let option = {
                color: ["#fbce45", "#FF8A8A", "#25b0f3"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        crossStyle: {
                            color: "#999",
                        },
                    },
                },
                grid: {
                    lineStyle: {
                        type: 'dashed', // 设置网格线为虚线
                        dashArray: [5, 5]
                    },
                    borderWidth: 0, // 确保网格线的样式不会被默认边框样式覆盖
                    top: "15%",
                    left: "2%",
                    right: "5%",
                    bottom: "2%",
                    containLabel: true,
                },
                legend: {
                    data: ["数量", "数量环比"],
                    left: "35%",
                    top: "8%",
                    textStyle: {
                        color: "#00CCFF",
                        fontSize: 16,
                    },
                },
                xAxis: {
                    type: "category",
                    // axisPointer: {
                    //     type: "shadow",
                    // },
                    axisLine: {
                        lineStyle: {
                            color: "#61B9C8",
                        },
                    },
                    data: this.month,
                },
                yAxis: [
                    {
                        type: "value",
                        splitLine: {
                            show: false,
                        },
                        name: "数量",
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#61B9C8",
                            },
                        },
                        axisLabel: {
                            formatter: "{value}",
                            textStyle: {
                                fontFamily: "Microsoft YaHei",
                                color: "#61B9C8",
                            },
                        },
                    },
                ],
                series: [
                    {
                        type: "bar",
                        barWidth: "50%",
                        data: this.listData,
                        label: {
                            show: true,
                            position: "top",
                            textStyle: {
                                color: "#fff",
                                fontSize: "7px",
                            },
                            // formatter: "{c}",
                        },
                        itemStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                // 渐变背景色
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: "#0599E4",
                                    },
                                    {
                                        offset: 1,
                                        color: "#25D2DE",
                                    },
                                ],
                                global: false,
                            },
                        },
                    },
                    {
                        type: "line",
                        symbol: "circle",
                        symbolSize: 8,
                        // 设置曲线
                        // 多Y轴，对应yAxis索引为1的轴
                        yAxisIndex: 0,
                        data: this.listData,
                        label: {
                            position: "top",
                            textStyle: {
                                color: "#fff",
                                fontSize: "7px",
                            },
                            formatter: "{c}",
                        },
                        itemStyle: {
                            color: "#CF9622",
                            lineStyle: {
                                color: "#CF9622",
                                borderColor: '#fff', // 数据点边框颜色
                                borderWidth: 2 // 数据点边框宽度
                            },
                        },
                    },
                ],
            };
            let myChart = echarts.init(document.getElementById("echarts"));

            myChart.clear();
            myChart.resize();
            myChart.setOption(option);
        },
    },
    watch:{
        echartsData: {
            deep: true,
            immediate: true,
            handler(newVal) {
                if (!newVal) return;
                if (newVal) {
                    this.$nextTick(() => {
                        // 全量替换配置数据（触发响应式更新）
                        this.listData  = newVal.tiaojie_data_arr;
                        this.month  = newVal.yue_arr;
                        this.setChart();
                    });
                }
            },
        },
    }
}
</script>

<style scoped lang="scss">
.echartsBox{
    width: 100%;
    height: 80%;
}
.echarts{
    width: 100%;
    height: 100%;
}
.title{
    display: flex;
    align-items: center;
    div{
        margin-right: 20px;
    }
    img{
        width: 16px;
    }
}
</style>